<template>
  <div>
    <b-modal
        v-model="modalActive"
        hide-footer
        id="modal-center"
        centered
        :title="$t('message.Lang_level')">
      <b-form-group
          label="Nomi"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="knowledge_level.name_uz"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_ru')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="knowledge_level.name_ru"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_en')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="knowledge_level.name_en"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_kr')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="knowledge_level.name_kr"
            required
        />
      </b-form-group>
      <div
          style="margin-top: 30px; margin-left: 150px">
        <b-button
            variant="outline-primary"
            @click="handleClick"
        >{{$t('message.Cancel')}}
        </b-button>
        <b-button
            @click="handleSubmit"
            style="margin-left: 10px"
            variant="primary"
        >{{$t('message.Add')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {addLanguageLevels, editLanguageLevel, getLangLevelById} from "../../../../../../api/language-level";

export default {
  name: "KnowledgeModal",
  props: {
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      knowledge_level: {
        name_uz: '',
        name_ru: '',
        name_en: '',
        name_kr: ''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchKnowledgeLevel(){
      getLangLevelById({ id: this.id}).then(response => {
        this.knowledge_level = response.data.data
      })
    },
    handleSubmit() {
      if (this. knowledge_level.name_uz
          && this. knowledge_level.name_ru
          && this. knowledge_level.name_en
          && this. knowledge_level.name_kr) {
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editLanguageLevel(this.knowledge_level).then(response => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addLanguageLevels(this.knowledge_level).then(response => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(value) {
        if(value) {
          this.fetchKnowledgeLevel()
        }
      }
    }
  },
}
</script>

<style scoped>

</style>




